import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { listMyPayments } from "../api";
import type { PaymentStatusFilter } from "../api";

export interface UseMyPaymentsParams {
  status: PaymentStatusFilter;
  page: number;
  pageSize?: number;
}

export const MY_PAYMENTS_KEY = (params: UseMyPaymentsParams) =>
  ["subscription", "payments", params.status, params.page, params.pageSize ?? 10] as const;

export function useMyPayments(params: UseMyPaymentsParams) {
  return useQuery({
    queryKey: MY_PAYMENTS_KEY(params),
    queryFn: () => listMyPayments(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
